module.exports = __webpack_public_path__ + "static/media/carousel-3.68dff7c9.jpg";